import script from "./ScreenSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreenSettings.vue?vue&type=script&setup=true&lang=js"

import "./ScreenSettings.vue?vue&type=style&index=0&id=b228965c&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b228965c"]])

export default __exports__